import { Injectable } from '@angular/core';
import {Product} from "../../../../models/product";


export interface ListingState {
    products:   Product[];
    totalPages: number;
    offset:     number;
    scrollY:    number;
}

@Injectable({ providedIn: 'root' })
export class ListingStateService {

    private cache = new Map<string, ListingState>();

    /** Call this before [routerLink] navigation */
    save(key: string, state: ListingState): void {
        this.cache.set(key, { ...state, scrollY: window.scrollY });
    }

    /** Returns saved state or null */
    restore(key: string): ListingState | null {
        return this.cache.get(key) ?? null;
    }

    clear(key: string): void {
        this.cache.delete(key);
    }
}